const SCROLL_HANDLER_KEY = '__whenScrollEndsHandler__'

function removeListener (el) {
  const handler = el?.[SCROLL_HANDLER_KEY]

  if (!handler) {
    return
  }

  el.removeEventListener('scroll', handler)
  delete el[SCROLL_HANDLER_KEY]
}

function addListener (el, binding) {
  removeListener(el)

  const handler = () => {
    if (binding?.value?.condition === false) {
      return
    }

    if (el.offsetHeight + el.scrollTop >= el.scrollHeight) {
      binding?.value?.callback?.()
    }
  }

  el[SCROLL_HANDLER_KEY] = handler
  el.addEventListener('scroll', handler)
}

export default {
  mounted (el, binding) {
    addListener(el, binding)
  },
  updated (el, binding) {
    addListener(el, binding)
  },
  unmounted (el) {
    removeListener(el)
  }
}
